import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import RoleRequestService from "./role_request_service";
import {Application} from "../../utils/types";
import {RoleRequestState} from "./types";

export const whitelistApply = createAsyncThunk(
    "roleRequests/whitelistApply",
    async (payload: Partial<Application>, {rejectWithValue}) => {
        try {
            // Call the register endpoint from the API
            return RoleRequestService.whitelistApply(payload);
        } catch (error: any) {
            // If server error, throw error
            return rejectWithValue(error.response.data.message || error.message);
        }
    }
);

export const getWhitelistApplication = createAsyncThunk(
    "roleRequests/getWhitelistApplication",
    async (_, {rejectWithValue}) => {
        try {
            // Call the login endpoint from the API
            return RoleRequestService.getWhitelistApplication();

        } catch (error: any) {
            // If server error, throw error
            return rejectWithValue(error.response.data.message || error.message);
        }
    }
);

export const directorApply = createAsyncThunk(
    "roleRequests/directorApply",
    async (payload: Partial<Application>, {rejectWithValue}) => {
        try {
            // Call the register endpoint from the API
            return RoleRequestService.directorApply(payload);
        } catch (error: any) {
            // If server error, throw error
            return rejectWithValue(error.response.data.message || error.message);
        }
    }
);

export const getDirectorApplication = createAsyncThunk(
    "roleRequests/getDirectorApplication",
    async (_, {rejectWithValue}) => {
        try {
            // Call the login endpoint from the API
            return RoleRequestService.getDirectorApplication();

        } catch (error: any) {
            // If server error, throw error
            return rejectWithValue(error.response.data.message || error.message);
        }
    }
);

const initialState: RoleRequestState = {
    whitelist_application: null,
    director_application: null,
    loading: false,
    error: null
}

const roleRequestSlice = createSlice({
    name: "roleRequests",
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(whitelistApply.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(whitelistApply.fulfilled, (state, action) => {
            state.loading = false;
            state.whitelist_application = action.payload;
        });

        builder.addCase(whitelistApply.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        });

        builder.addCase(getWhitelistApplication.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(getWhitelistApplication.fulfilled, (state, action) => {
            state.loading = false;
            state.whitelist_application = action.payload;
        });

        builder.addCase(getWhitelistApplication.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        });

        builder.addCase(directorApply.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(directorApply.fulfilled, (state, action) => {
            state.loading = false;
            state.director_application = action.payload;
        });

        builder.addCase(directorApply.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message as string;
        });

        builder.addCase(getDirectorApplication.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(getDirectorApplication.fulfilled, (state, action) => {
            state.loading = false;
            state.director_application = action.payload;
        });

        builder.addCase(getDirectorApplication.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message as string;
        });
    }
});

export default roleRequestSlice.reducer;